import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getDiscountById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateDiscount } from "..";

const EditDiscount = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getBrand();
        else setLoading(false);
    }, [id]);

    const getBrand = async () => {
        try {
            const { data } = await getDiscountById(id);
            setItem(data.discount);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };

    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateDiscount from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_discount' />
};

export default EditDiscount;